export enum WayfarersFlags {
    BackgroundAuthFormVersion = 'BACKGROUND_AUTH_FORM_VERSION',
    UseContractSearchV2 = 'use-contract-search-v2',
    UnlinkBackButtonFromBrowserAction = 'unlink-back-button-from-browser-action',
    HideW2CreateMarginButtonFor1099Jobs = 'hide-w2-create-margin-button-for-1099-jobs',
    LocumsMarginAddNullForHoursPerShiftDropdown = 'locums-margin-add-null-for-hours-per-shift-dropdown',
    HideCadenceFieldFromExpenseSection = 'hide-cadence-field-from-expense-section',
    Show1099GMCsOnTravelContractsCandidatePage = 'show-1099-gmcs-on-travel-contracts-candidate-page',
    NovaLocumsLeave1099GmcDialog = 'nova-locums-leave-1099-gmc-dialog',
    EnableLocums1099MaxDaysValidation = 'enable-locums-1099-max-days-validation',
    EnableLocumsMissingDegreeCheck = 'enable-locums-missing-degree-check',
    ShowGrossProfitMarginIcon = 'show-gross-profit-margin-icon',
    EnableSpecialtyPersistenceLocums1099 = 'enable-specialty-persistence-locums-1099',
    LinkLocums1099MarginsToCandidatePayroll = 'link-locums-1099-margins-to-candidate-payroll',
    Locums1099SubmittalCreatePresentation = 'locums-1099-submittals-create-presentation',
    EnableLocumsMarginIsFormDirtyWithNormalization = 'enable-locums-margin-is-form-dirty-with-normalization',
    EnableLocums1099SubmittalsGmcRelatedFields = 'locums-1099-submittals-gmc-related-fields',
    LocumsSubmittalsHideInSystemSubmittalOption = 'locums-submittals-hide-in-system-submittal-option'
}
